<template>
  <div class="banner-size">
    <b-carousel
      id="myCarousel"
      v-model="slide"
      :interval="4000"
      :controls="false"
      background="#ffffff"
      img-width="100vw"
      img-height="100%"
      style="text-shadow: 1px 1px 2px #333; "
      class=" rounded-lg"
    >
      <ol class="carousel-indicators">
        <li v-for="(item,$index) in list" :key="$index"  data-target="#myCarousel" :class="slide==$index?'active':''" @click="slide=$index"></li>
        <!--<li data-target="#myCarousel" :class="slide==1?'active':''" @click="slide=1"></li>-->
        <!--<li data-target="#myCarousel" :class="slide==2?'active':''" @click="slide=2"></li>-->
        <!--<li data-target="#myCarousel" :class="slide==3?'active':''" @click="slide=3"></li>-->
        <!--<li data-target="#myCarousel" :class="slide==4?'active':''" @click="slide=4"></li>-->
      </ol>
      <b-carousel-slide v-for="(item,$index) in list" :key="$index" :img-src="item.banner"></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "banner",
    data() {
      return {
        slide: 0,
        sliding: null,
        list: [
          {banner: 'https://static.zuiqiangyingyu.cn/wonder-website/banner/banner4.png'},
          {banner: 'https://static.zuiqiangyingyu.cn/wonder-website/banner/banner5.png'},
          {banner: 'https://static.zuiqiangyingyu.cn/wonder-website/banner/banner1.png'},
          {banner: 'https://static.zuiqiangyingyu.cn/wonder-website/banner/banner2.png'},
          {banner: 'https://static.zuiqiangyingyu.cn/wonder-website/banner/banner3.png'},
        ],
        listUrl: 'https://api.zuiqiangyingyu.cn/a81iWQArSR9sg7b9ih.php/api/website/banner/Get_banner_list',
      }
    },
    mounted() {

    },
    created() {
      this.getList();
    },
    methods: {
      getList() {
        axios.get(this.listUrl).then((response) => {
          let $data = response.data;
          if ($data.c == 0) {
            if ($data.d.length > 0) {
              this.list = $data.d;
            }
          } else {
          }

        }).catch((error) => {
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
  .banner-size {
    z-index: -1;
  }

  .carousel-indicators {
    margin-left: 60%;
    margin-bottom: 1.3rem;
  }

  .carousel-indicators li {
    border: none;
  }

  .carousel-indicators > li {
    height: 0.4rem;
    width: 0.4rem;
    border-radius: 0.2rem;
    background-color: #0E99C4;
  }

  .carousel-indicators > li.active {
    background-color: #24D1F6;
    border-radius: 0.2em;
    width: 0.6rem;
    height: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/banner.vue